<template>
  <v-container>
    <!-- <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col class="d-flex pt-0">
        <img
          src="../../assets/icons/sorts/resource_center.png"
          class="tcdc-resource-center-layout-icon mr-4"
        />
        <span class="text-tcdc-green bold header text-uppercase">resource center</span>
      </v-col>
    </v-row>-->
    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  created() {
    this.items[0].text = this.branchName;
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: '/',
      },
      {
        text: "PROGRAM",
        disabled: true,
      }
    ]
  })
};
</script>

<style scoped>
.tcdc-resource-center-layout-icon {
  height: 35px;
  object-fit: contain;
}
</style>
